const person = {
  defaults: {
    isActive: false,
    isAdmin: false,
    isInternal: false,
    managerPersonId: null,
    personEmail: null,
    personId: null,
    personNameFirst: null,
    personNameLast: null,
  },
}

export default person
